import { createContext, useEffect, useState, useContext, useCallback } from 'react';
import './menu-main.scss';
import Menu, { Item } from 'devextreme-react/menu';
import { AccountContext } from '../context/account-context';
export default function MenuMain() {

    const [account, setAccount] = useContext(AccountContext);

    const handleItemClick = useCallback((e) => {

        if (e.itemIndex == 2) {
            localStorage.removeItem("account");
            setAccount(null);
        }
        
    }, []);

    if (!account) return <></>

    return (
        <Menu className="menuMain" onItemClick={handleItemClick} >
            <Item text="Повідомлення" selected={true} />
            <Item text="Аналітика" />
            <Item text="Вихід" />
        </Menu>
    );
}

